//
// Menu related functions
// ================================================================================

function menu() {

    /*
     * There is a menu for Mobile devices; '.menu'.
     * And a layer containing the mobile logo and menu toggle; '.nav'.
     *
     * TO DO:
     * Expand a11y with https://www.w3.org/TR/wai-aria-practices/examples/menu-button/menu-button-links.html
     *
    **/


    const menu = document.querySelector('.menu');
    const toggle = document.querySelector('.nav__toggle');


    function checkBreackpoint() {
        // If screensize is bigger than mobile, change a11y params
    };


    function menuToggle() {

        toggle.addEventListener('click', () => {
            console.log('click!');
            if ( menu.classList.contains('menu--open') ) {
                menu.classList.remove('menu--open');
                menu.removeAttribute('aria-expanded');
                toggle.classList.remove('nav__toggle--open');
            } else {
                menu.classList.add('menu--open');
                menu.setAttribute('aria-expanded', 'true');
                toggle.classList.add('nav__toggle--open');
            }
        });
    };


    menuToggle();
};

export { menu };
